/**
 * PrivacyARPrivacyPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacyARPrivacyPage
 */

import { usePrivacyARPrivacyPageLogic } from '@/hooks/traits/usePrivacyARPrivacyPageLogic';
import type { PrivacyARPrivacyPageConfig } from '@/hooks/traits/usePrivacyARPrivacyPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacyARPrivacyView as PrivacyARPrivacyViewEntity } from '@app/shared';
import { PrivacyARPrivacyFooterView } from '@/components/traits/PrivacyARPrivacyFooterView';
import { PrivacyARPrivacyTextView } from '@/components/traits/PrivacyARPrivacyTextView';
import { PrivacyARPrivacyHeaderView } from '@/components/traits/PrivacyARPrivacyHeaderView';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface PrivacyARPrivacyPageViewProps {
  config?: Partial<PrivacyARPrivacyPageConfig>;
}

export function PrivacyARPrivacyPageView({ config: propsConfig }: PrivacyARPrivacyPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacyARPrivacyPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacyARPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacyAR" trait="PrivacyARPrivacyPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="PrivacyARPrivacyPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><PrivacyARPrivacyHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box className="py-16 md:py-24" fullWidth={true} bg="transparent"><PrivacyARPrivacyTextView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Box><PrivacyARPrivacyFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default PrivacyARPrivacyPageView;
